import React from "react";
import '../Home/homePage.scss';

const NEW_SITE_URL = 'https://pych-public.web.app';

// The legacy site is retired: the landing page now does nothing but send
// visitors to the new public website.
const HomePage = () => {
  return (
    <div className='movedPage'>
      <div className='movedCard'>
        <p className='movedBsd'> בס"ד </p>
        <img className="movedLogo" src="home-logo-v3.png" alt="logo-pych" />
        <h1 className='movedTitle'>האתר עבר לכתובת חדשה</h1>
        <p className='movedText'>
          אתר פאייכלה החדש כבר באוויר, עם חוויית הזמנה מהירה ונוחה יותר.
          <br />
          כל ההזמנות מתבצעות מעכשיו באתר החדש בלבד.
        </p>
        <a className='movedBtn' href={NEW_SITE_URL}>
          מעבר לאתר החדש
        </a>
      </div>
    </div>
  );
};

export default HomePage;
